<template>
        <div class="sidebar do-not-print">
            <div class="sidebar__content" :class="{ 'sidebar__content--open': open, 'sidebar__content--settled': accordionReady }">
                <perfect-scrollbar :class="{ 'sidebar__scrollbar': !open }" :options="scrollbarOptions">
                    <div class="sidebar__nav-container">
                        <ul class="sidebar__nav">
                            <li v-for="items in filteredLinks" :key="items.name" class="sidebar__nav-item"
                            @mouseenter="showTooltip(items.name, $event)" @mouseleave="hideTooltip(items.name)">
                                <router-link v-if="items.path" 
                                    class="sidebar__nav-link" 
                                    :class="{ 'sidebar__nav-link--active': isParentActive(items) }"
                                    :to="items.path"
                                    @click="closeOnMobile">
                                <div @click="toggleGroup(items.name)">
                                    <span class="sidebar__nav-icon" :class="items.icon"></span>
                                    <span class="sidebar__nav-tittle" :class="{ 'sidebar__nav-link--close': !open }">{{ items.name }}</span>
                                    <span
                                        v-if="items.visibleChildren.length"
                                        class="sidebar__nav-arrow"
                                        :class="[isGroupOpen(items.name) ? 'fas fa-angle-down' : 'fas fa-angle-right', { 'sidebar__nav-link--close': !open }]"
                                    ></span>
                                </div> 
                                </router-link>
                                <button
                                    v-else
                                    type="button"
                                    class="sidebar__nav-link"
                                    :class="{ 'sidebar__nav-link--active': isParentActive(items) }"
                                    @click="toggleGroup(items.name)"
                                >
                                    <span class="sidebar__nav-icon" :class="items.icon"></span>
                                    <span class="sidebar__nav-tittle" :class="{ 'sidebar__nav-link--close': !open }">{{ items.name }}</span>
                                    <span
                                        v-if="items.visibleChildren.length"
                                        class="sidebar__nav-arrow"
                                        :class="[isGroupOpen(items.name) ? 'fas fa-angle-down' : 'fas fa-angle-right', { 'sidebar__nav-link--close': !open }]"
                                    ></span>
                                </button>
                            <div class="sidebar__nav-list" :class="{ 'sidebar__nav-list--open': open && isGroupOpen(items.name) }">
                                <div class="sidebar__nav-list-inner">
                                    <li v-for="item in items.visibleChildren" :key="item.name" class="sidebar__nav-item">
                                        <router-link :to="item.path" class="sidebar__nav-sub-link" active-class="sidebar__nav-sub-link--active" @click.capture="onChildNavClick(item, $event)" @click="closeOnMobile">
                                            <span :class="{ 'sidebar__nav-link--close': !open }">{{ item.name }}</span>
                                        </router-link>
                                    </li>
                                </div>
                            </div>
                            <div 
                                v-if="items.visibleChildren && items.visibleChildren.length > 0 && !open && tooltip[items.name]" 
                                class="sidebar__tooltip">
                                <div class="sidebar__nav-subtitle">
                                    {{ items.name }}
                                </div>
                                <ul class="sidebar__tooltip-list">
                                    <li v-for="item in items.visibleChildren" :key="item.name" class="sidebar__tooltip-item">
                                        <router-link :to="item.path" class="sidebar__tooltip-link" active-class="sidebar__tooltip-link--active" @click.capture="onChildNavClick(item, $event)" @click="closeOnMobile">{{ item.name }}</router-link>
                                </li>
                                </ul>
                            </div>
                            </li>
                        </ul>
                    </div>
                </perfect-scrollbar>
                <div class="sidebar__footer">
                    <ul class="sidebar__nav sidebar__nav--other-links">
                        <li v-for="item in sidebar.otherLinks" :key="item.name" class="sidebar__nav-item">
                            <a
                                v-if="item.href"
                                :href="item.href"
                                target="_blank"
                                rel="noopener"
                                class="sidebar__nav-link"
                                @click="closeOnMobile"
                            >
                                <span class="sidebar__nav-icon" :class="item.icon"></span>
                                <span class="sidebar__nav-text" :class="{ 'sidebar__nav-link--close': !open }">{{ item.name }}</span>
                            </a>
                            <router-link
                                v-else
                                :to="item.path"
                                class="sidebar__nav-link"
                                active-class="sidebar__nav-link--active"
                                @click="closeOnMobile"
                            >
                                <span class="sidebar__nav-icon" :class="item.icon"></span>
                                <span class="sidebar__nav-text" :class="{ 'sidebar__nav-link--close': !open }">{{ item.name }}</span>
                            </router-link>
                        </li>
                        <button
                            type="button"
                            class="sidebar__nav-link sidebar__nav-link--logout"
                            style="appearance: none;"
                            @click="$emit('logout')"
                        >
                            <span class="sidebar__nav-icon fas fa-sign-out-alt"></span>
                            <span :class="{ 'sidebar__nav-link--close': !open }">Log out</span>
                        </button>
                    </ul>
                    <button type="button" class="sidebar__button-collapse" :class="{ 'sidebar__button-collapse--open': open }" @click="$emit('toggleSidebar')">
                        <svg width="14" height="12" viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M9.98614 7.20303L16.3611 0.828027C16.8018 0.387402 17.5143 0.387402 17.9502 0.828027L19.0096 1.8874C19.4502 2.32803 19.4502 3.04053 19.0096 3.47646L14.4955 7.9999L19.0143 12.5187C19.4549 12.9593 19.4549 13.6718 19.0143 14.1077L17.9549 15.1718C17.5143 15.6124 16.8018 15.6124 16.3658 15.1718L9.99082 8.79678C9.54551 8.35615 9.54551 7.64365 9.98614 7.20303ZM0.986135 8.79678L7.36114 15.1718C7.80176 15.6124 8.51426 15.6124 8.9502 15.1718L10.0096 14.1124C10.4502 13.6718 10.4502 12.9593 10.0096 12.5233L5.49551 7.9999L10.0143 3.48115C10.4549 3.04053 10.4549 2.32803 10.0143 1.89209L8.95489 0.828027C8.51426 0.387402 7.80176 0.387402 7.36582 0.828027L0.990823 7.20303C0.54551 7.64365 0.54551 8.35615 0.986135 8.79678Z"
                                fill="#555555" />
                        </svg>
                    </button>
                </div>
            </div>
            <div class="sidebar__backdrop" :class="{ 'sidebar__backdrop--open': open }" @click="$emit('toggleSidebar')"></div>
        </div>
</template>

<script>
import { sidebar, scopes } from '@/data';
import { filterMenuLinks } from '@/utils/menu-links.util';
import { PerfectScrollbar } from 'vue3-perfect-scrollbar' ;

import { mapActions, mapState } from 'vuex';
export default {
    components: { PerfectScrollbar },
    name: 'Sidebar',
    props: {
        open: {
            type: Boolean,
            default: false,
        }
    },
    emits: ['toggleSidebar', 'logout', 'closeSidebar'],
    data() {
        return {
            sidebar,
            scopes,
            scrollbarOptions: {
                suppressScrollX: true,
                wheelPropagation: true,
                wheelSpeed: 1,
                minScrollbarLength: 20,
            },
            filter: false,
            links: [],
            openGroups: {
                Accounts: true,
                Process: true,
                Administration: true,
            },
            tooltip: {},
            tooltipTimeouts: {},
            accordionReady: false,
            accordionReadyTimer: null,
        };
    },
    computed: {
        ...mapState(['globalFilters']),
        filteredLinks() {
            return filterMenuLinks(this.links, {
                accountSelected: this.globalFilters.account != 0,
                can: (scope, bypassPositions) => this.CAN(scope, undefined, bypassPositions),
            });
        }
    },
    mounted() {
        this.checkFilters();
        this.resetDefaultOpenGroups();
        this.accordionReady = this.open;
        window.addEventListener('scroll', this.updateAllTooltips, true);
        window.addEventListener('resize', this.updateAllTooltips);
    },
    beforeUnmount() {
        window.removeEventListener('scroll', this.updateAllTooltips, true);
        window.removeEventListener('resize', this.updateAllTooltips);
        window.clearTimeout(this.accordionReadyTimer);
    },
    watch: {
        open: {
            handler(newVal) {
                window.clearTimeout(this.accordionReadyTimer);
                this.accordionReady = false;
                if (newVal === false) {
                    this.openGroups = {
                        Accounts: false,
                        Process: false,
                        Administration: false,
                    };

                    this.scrollbarOptions = {
                        suppressScrollX: true,
                        suppressScrollY: true, 
                        wheelPropagation: false,
                        minScrollbarLength: 20,
                    };
                } else {
                    this.scrollbarOptions = {
                        suppressScrollX: true,
                        wheelPropagation: true,
                        wheelSpeed: 1,
                        minScrollbarLength: 20,
                    };
                    this.resetDefaultOpenGroups();
                    this.accordionReadyTimer = window.setTimeout(() => {
                        this.accordionReady = true;
                    }, 500);
                }
            },
        },
        globalFilters: {
            handler(newVal) {
                if (newVal.account != 0) {
                    this.filter = true;
                    this.applyAccountFilterPath(`/accounts/info?id=${newVal.account.id}`);
                    this.checkFilters();
                } else {
                    this.filter = false;
                    this.applyAccountFilterPath('/accounts');
                    this.checkFilters();
                }
            },
            deep: true,
        },
        $route() {
            this.autoOpenActiveGroups();
        },
    },
    methods: {
        ...mapActions({
            clearAccountFilter: 'globalFilters/clearAccountFilter',
        }),
        onChildNavClick(item, event) {
            const modified_click = event.metaKey
                || event.altKey
                || event.ctrlKey
                || event.shiftKey
                || (event.button !== undefined && event.button !== 0);
            const keeps_current_link = item.name !== 'Accounts'
                || this.globalFilters.account == 0
                || modified_click;
            if (keeps_current_link) {
                return;
            }
            event.preventDefault();
            this.clearAccountFilter();
            this.$router.push({ name: 'accounts' });
        },
        closeOnMobile() {
            if (this.open && window.innerWidth <= 992) {
                this.$emit('closeSidebar');
            }
        },
        showTooltip(group, event) {
            if (!this.open) {
                if (this.tooltipTimeouts[group]) {
                    clearTimeout(this.tooltipTimeouts[group]);
                    delete this.tooltipTimeouts[group];
                }
                this.tooltip = { ...this.tooltip, [group]: true };
                this.$nextTick(() => {
                    this.updateTooltipPosition(group, event);
                    this.attachTooltipListeners(group, event);
                });
            }
        },
        updateTooltipPosition(groupName, event) {
            if (!event || !event.currentTarget) {
                return;
            }
            const element = event.currentTarget;
            const rect = element.getBoundingClientRect();
            const tooltip = element.querySelector('.sidebar__tooltip');
            if (tooltip) {
                const gap = 2;
                const left = rect.right + gap;
                const top = rect.top;
                tooltip.style.left = `${left}px`;
                tooltip.style.top = `${top}px`;
                
                const maxHeight = window.innerHeight - top - 10;
                tooltip.style.maxHeight = `${maxHeight}px`;
                
                const tooltipRect = tooltip.getBoundingClientRect();
                if (left + tooltipRect.width > window.innerWidth) {
                    tooltip.style.left = `${rect.left - tooltipRect.width - gap}px`;
                }
            }
        },
        updateAllTooltips() {
            if (this.open) {
                return;
            }
            this.$nextTick(() => {
                document.querySelectorAll('.sidebar__nav-item').forEach(item => {
                    const tooltip = item.querySelector('.sidebar__tooltip');
                    if (tooltip && tooltip.style.display !== 'none') {
                        const rect = item.getBoundingClientRect();
                        const left = rect.right + 5;
                        const top = rect.top;
                        tooltip.style.left = `${left}px`;
                        tooltip.style.top = `${top}px`;
                        
                        const maxHeight = window.innerHeight - top - 10;
                        tooltip.style.maxHeight = `${maxHeight}px`;
                    }
                });
            });
        },
        hideTooltip(group) {
            if (this.tooltipTimeouts[group]) {
                clearTimeout(this.tooltipTimeouts[group]);
            }
            this.tooltipTimeouts[group] = setTimeout(() => {
                this.tooltip = { ...this.tooltip, [group]: false };
                delete this.tooltipTimeouts[group];
            }, 200);
        },
        attachTooltipListeners(groupName, event) {
            if (!event || !event.currentTarget) {
                return;
            }
            const element = event.currentTarget;
            const tooltip = element.querySelector('.sidebar__tooltip');
            if (tooltip) {
                const clearTooltipTimeout = () => {
                    if (this.tooltipTimeouts[groupName]) {
                        window.clearTimeout(this.tooltipTimeouts[groupName]);
                        delete this.tooltipTimeouts[groupName];
                    }
                };
                
                const handleMouseEnter = () => {
                    clearTooltipTimeout();
                };
                
                const handleMouseLeave = () => {
                    this.hideTooltip(groupName);
                };
                
                if (tooltip._tooltipListeners) {
                    tooltip.removeEventListener('mouseenter', tooltip._tooltipListeners.mouseenter);
                    tooltip.removeEventListener('mouseleave', tooltip._tooltipListeners.mouseleave);
                }
                
                tooltip.addEventListener('mouseenter', handleMouseEnter);
                tooltip.addEventListener('mouseleave', handleMouseLeave);
                
                tooltip._tooltipListeners = {
                    mouseenter: handleMouseEnter,
                    mouseleave: handleMouseLeave
                };
            }
        },
        toggleGroup(group) {
            if (!this.open) {
                return;
            }
            this.openGroups = {
                ...this.openGroups,
                [group]: !this.openGroups[group],
            };
        },
        isGroupOpen(group) {
            return !!this.openGroups[group];
        },
        findAccountsLink() {
            return this.sidebar.links.find((link) => link.name === 'Accounts');
        },
        applyAccountFilterPath(path) {
            const accounts_link = this.findAccountsLink();
            if (!accounts_link || !accounts_link.children || !accounts_link.children[0]) {
                return;
            }
            accounts_link.children[0].path = path;
        },
        isParentActive(parent) {
            const path = this.$route.path;
            const isUnder = (base) => path === base || path.startsWith(`${base}/`);
            if (parent.path && !parent.visibleChildren.length) {
                return isUnder(parent.path);
            }
            return parent.visibleChildren.some((child) => isUnder(child.path));
        },
        checkFilters() {
            if (this.globalFilters.account != 0) {
                this.applyAccountFilterPath(`/accounts/info?id=${this.globalFilters.account.id}`);
            }
            this.links = this.sidebar.links;
        },
        resetDefaultOpenGroups() {
            if (!this.open) {
                return;
            }
            this.openGroups = {
                Accounts: true,
                Process: true,
                Administration: true,
            };
            this.autoOpenActiveGroups();
        },
        autoOpenActiveGroups() {
            if (!this.open) {
                return;
            }
            const next = { ...this.openGroups };
            this.filteredLinks.forEach((link) => {
                if (link.visibleChildren.length && this.isParentActive(link)) {
                    next[link.name] = true;
                }
            });
            this.openGroups = next;
        },
    },
};
</script>

<style lang="scss">
.sidebar {
    position: relative;
    &__content {
        background-color: $white;
        box-shadow: 0 0 12px rgba(#000000, 0.06);
        height: calc(100vh - 56px);
        left: 0;
        position: fixed;
        top: 56px;
        transition: 500ms width, 500ms min-width, 500ms max-width, 500ms left, 500ms transform;
        width: var(--sidebar-collapsed);
        min-width: var(--sidebar-collapsed);
        max-width: var(--sidebar-collapsed);
        z-index: 1029;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: stretch;
        .custom-scrollbar {
            overflow: hidden;
            transition: overflow 0.3s ease;
            height: 100%;
            scrollbar-width: thin;

            &::-webkit-scrollbar {
                width: 6px;
            }

            &::-webkit-scrollbar-thumb {
                background: #CACFD9;
                opacity: .45;
                border-radius: 4px;
            }

            &::-webkit-scrollbar-track {
                background-color: transparent;
            }

            &:hover {
                overflow-y: auto;
                overflow-x: hidden;
            }
        }
        
        @media (max-width: 992px) {
            height: 100dvh;
            left: 0;
            top: 0;
            transform: translateX(calc(-100% - 16px));
            z-index: 1031;
        }
    
        &--open {
            align-items: stretch;
            max-width: var(--sidebar-open);
            min-width: var(--sidebar-open);
            width: var(--sidebar-open);

            @media (max-width: 992px) {
                left: 0;
                transform: none;
            }
        }
    }

    &__scrollbar {
        overflow-y: visible !important;
        overflow-x: visible !important;
    }

    .ps {
        flex: 1 1 auto;
        min-height: 0;
        overflow: hidden !important;
    }

    .ps__rail-x,
    .ps__rail-y {
        z-index: 1;
    }

    .ps--active-x > .ps__rail-x,
    .ps--active-y > .ps__rail-y {
        display: block;
    }

    &__brand {
        align-items: center;
        display: flex;
        height: 90px;
        justify-content: center;
        width: 90%;
    }

    &__brand-logo {
        width: 150px;
    }

    &__nav-container {
        display: flex;
        flex-direction: column;
        height: 100%;
        justify-content: space-between;
        overflow: visible;
        position: relative;
        width: 100%;
    }

    &__nav {
        list-style: none;
        margin: 0;
        overflow: visible;
        padding: 16px 10px;
        position: relative;

        &--other-links {
            border-top: 1px solid $ecart-secondary-100;
            margin-bottom: 0;
        }
    }

    &__nav-item {
        width: 100%;
        position: relative;
        z-index: 1;
        
        &:hover {
            z-index: 1032;
        }
        
        &:hover .sidebar__tooltip {
            display: block !important;
        }
    }

    &__nav-link {
        appearance: none;
        background: transparent;
        border: none;
        color: $general-black;
        opacity: 1;
        display: block;
        transition: 200ms all;
        transition-delay: 150ms;
        transition-property: opacity;
        font-weight: 500;
        padding: 6px 6px;
        text-align: left;
        text-decoration: none;
        width: 100%;
        font-size: 12px;
        margin-top: 5px;
        overflow: hidden;
        border-radius: 5px;
        cursor: pointer;

        &--close {
            display: none;
            opacity: 0;
        }
        
        &--active {
            background-color: $ecart-primary-100;

            span {
                color: $ecart-primary;
            }
        }

        &:hover {
            background-color: $ecart-primary-100;
            color: $general-black;
        }

        &--logout {
            color: $danger;

            .sidebar__nav-icon {
                color: $danger;
            }

            &:hover {
                background-color: rgba($danger, 0.1);
                color: $danger;

                .sidebar__nav-icon {
                    color: $danger;
                }
            }
        }
    }

    .sidebar__content:not(.sidebar__content--open) {
        .ps {
            padding: 0 !important;
            width: 100%;
        }

        .ps__rail-x,
        .ps__rail-y {
            display: none !important;
        }

        .sidebar__nav-container {
            align-items: center;
        }

        .sidebar__nav {
            align-items: center;
            box-sizing: border-box;
            display: flex;
            flex-direction: column;
            padding: 12px 0;
            width: 100%;
        }

        .sidebar__nav-list {
            padding-left: 0;
            transition: none;
        }

        .sidebar__nav-item {
            align-items: center;
            display: flex;
            flex-direction: column;
            width: 100%;
        }

        .sidebar__nav-link {
            align-items: center;
            box-sizing: border-box;
            display: flex;
            height: 31px;
            justify-content: center;
            margin: 4px auto 0;
            padding: 0;
            text-align: center;
            width: 31px;

            > div {
                display: contents;
            }
        }

        .sidebar__nav-icon {
            align-items: center;
            display: flex;
            flex-shrink: 0;
            font-size: 14px;
            height: 31px;
            justify-content: center;
            line-height: 1;
            margin: 0;
            width: 31px;

            &::before {
                line-height: 1;
            }
        }
    }

    &__nav-list {
        display: grid;
        grid-template-rows: 0fr;
        overflow: hidden;
        padding-left: 20px;
        width: 100%;

        &--open {
            grid-template-rows: 1fr;
        }
    }

    &__content--settled .sidebar__nav-list {
        transition: grid-template-rows 0.2s ease;
    }

    &__nav-list-inner {
        min-height: 0;
        overflow: hidden;
    }
    
    &__nav-sub-link {
        background: transparent;
        border: none;
        border-left: 3px solid transparent;
        color: $general-black;
        opacity: 1;
        display: block;
        transition: opacity 0.2s ease;
        font-weight: 400;
        text-decoration: none;
        width: 100%;
        padding: 4px 10px;
        margin-top: 10px;
        border-radius: 5px;
        cursor: pointer;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;

        &--close {
            display: none;
            opacity: 0;
        }
        
        &--active {
            background-color: $ecart-primary-100;
            border-left-color: $ecart-primary;
            span {
                color: $ecart-primary;
            }
        }

        &:hover {
            background-color: $ecart-primary-100;
            color: $general-black;
        }
    }

    &__nav-icon {
        margin-right: 10px;
        margin-left: 10px;
        width: 16px;
        height: 16px;
        z-index: 1;
    }

    &__nav-subtitle {
        font-size: 14px;
        font-weight: 500;
        padding: 10px 12px;
        justify-content: center;
        align-items: center;
        display: flex;
        border-bottom: 1px solid $ecart-secondary-200;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    &__nav-tittle {
        font-size: 14px;
        line-height: 14px;
        overflow: hidden;
        padding-left: 10px;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    &__nav-arrow {
        width: 12px;
        height: 12px;
        padding-top: 5px;
        float: right;
        
    }

    &__tooltip {
        background: white;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
        padding: 0;
        border-radius: 4px;
        z-index: 1032;
        position: fixed;
        width: 220px;
        max-width: 220px;
        overflow: hidden;
        margin-left: 0;
        pointer-events: auto;
        
        &::before {
            content: '';
            position: absolute;
            left: -5px;
            top: 0;
            width: 5px;
            height: 100%;
            background: transparent;
        }
    }

    &__tooltip-list {
        list-style: none;
        padding: 0;
        margin: 0;
        max-height: 400px;
        overflow-y: auto;
        overflow-x: hidden;
        
        &::-webkit-scrollbar {
            width: 4px;
        }

        &::-webkit-scrollbar-thumb {
            background: #CACFD9;
            opacity: .45;
            border-radius: 2px;
        }

        &::-webkit-scrollbar-track {
            background-color: transparent;
        }
    }

    &__tooltip-item {
        list-style: none;
        width: 100%;
    }

    &__tooltip-link {
        display: block;
        padding: 8px 12px;
        color: $general-black;
        text-decoration: none;
        font-size: 14px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        border-left: 3px solid transparent;
        transition: all 0.2s ease;

        &--active {
            background-color: $ecart-primary-100;
            border-left-color: $ecart-primary;
            color: $ecart-primary;
        }

        &:hover {
            background-color: $ecart-primary-100;
            color: $general-black;
        }
    }

    @media (max-width: 992px) {
        &__backdrop {
            background-color:rgba(33, 40, 55, 0.5);
            display: none;
            height: auto;
            inset: 0;
            left: 0;
            position: fixed;
            top: 0;
            width: auto;
            z-index: 1030;

            &--open {
                display: block;
            }
        }
    }

    &__footer {
        flex-shrink: 0;
        position: relative;
        width: 100%;
    }

    &__button-collapse {
        align-items: center;
        background: $general-white;
        border: none;
        border-radius: 50%;
        cursor: pointer;
        display: flex;
        height: 32px;
        justify-content: center;
        padding: 0;
        position: absolute;
        right: 0;
        top: 50%;
        transform: translate(50%, -50%) rotate(180deg);
        transition: 500ms transform;
        width: 32px;
        z-index: 2;

        svg {
            display: block;
            height: 12px;
            width: 14px;
        }

        &--open {
            transform: translate(50%, -50%) rotate(0deg);
        }
    }
}
</style>
